// extracted by mini-css-extract-plugin
export default {"pageContainer":"commonPageLayout_pageContainer__yVf5-"};